import React from "react";
import "./floral.css";

const FloralBack = ({ data }) => {
  const { first_name, second_name, date, location } = data;

  return (
    <>
      <div className="postcard-wrapper postcard-floral postcard-back">
        <div className="postcard-safe">
          <div className="postcard-details postcard-back">
            <p className="postcard-names">
              {first_name}
              <br />
              &
              <br />
              {second_name}
            </p>
            <p className="postcard-getting-married">are getting married</p>
            <p className="postcard-date">{date}</p>
            <p className="postcard-date">{location}</p>
            <p className="postcard-followup">Formal invitation to follow</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default FloralBack;
